module.exports = __webpack_public_path__ + "media/success.7f074a31.wav";